import { SET_GUIDE_PROPERTY } from 'store/actions/guide';
import { setValueObjectByField } from 'helpers/object';

export default {
  [SET_GUIDE_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  }
};
